import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const shopApi = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: `${API}/admin` });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("cc_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fmt = (cents) => `R${((cents || 0) / 100).toFixed(2)}`;

export const apiImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export function formatApiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return fallback;
}

export const STATUS_LABELS = {
  new: "Order Received",
  awaiting_payment: "Awaiting Payment",
  pending_payment: "Payment Pending",
  paid: "Payment Confirmed",
  preparing: "Being Handmade",
  packed: "Packed",
  shipped: "On Its Way",
  delivered: "Delivered",
  cancelled: "Cancelled",
  payment_failed: "Payment Failed",
  payment_error: "Payment Error",
};

export const STATUS_STEPS = ["paid", "preparing", "packed", "shipped", "delivered"];
